module.exports = "<p>The artist on<br><em>Open My Glade</em> 1997</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room3/audio4/content.md
// module id = 838
// module chunks = 0